import { Section, P, Bullets, Kpi, Callout } from "./Primitives";

export const Cover = () => (
  <section id="copertina" data-testid="section-copertina" className="cover">
    <div className="flex justify-between items-start text-xs uppercase tracking-[0.25em] text-[var(--gold-light)]">
      <span>PartnerTech</span>
      <span>Documento riservato · Novembre 2026</span>
    </div>
    <div className="cover-body">
      <div className="kicker !text-[var(--gold-light)] mb-6">Piano esecutivo per la Proprietà</div>
      <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] text-[var(--cream)]">
        Piano di Sviluppo
        <br />
        Tecnologico e <em className="text-[var(--gold-light)]">Scalabilità</em>
      </h1>
      <div className="w-24 h-px bg-[var(--gold)] my-10" />
      <p className="font-display text-3xl text-[var(--cream)]">Bella Napoli</p>
      <p className="text-sm text-[rgba(247,241,230,0.7)] mt-2 tracking-wide">Pasticcerie artigianali · 7 punti vendita in Campania</p>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm text-[rgba(247,241,230,0.82)] border-t border-[rgba(176,141,87,0.4)] pt-6">
      <div><div className="kicker !text-[var(--gold-light)] mb-1">Presentato da</div>PartnerTech</div>
      <div><div className="kicker !text-[var(--gold-light)] mb-1">Consulente</div>Cristian D'Agostino</div>
      <div><div className="kicker !text-[var(--gold-light)] mb-1">Piattaforma</div>Synapse OS</div>
    </div>
  </section>
);

export const Executive = ({ payback }) => (
  <Section id="executive" num="01" kicker="Executive Summary" title="Un unico Cervello Digitale per sette pasticcerie">
    <P>
      Bella Napoli ha costruito in Campania un patrimonio raro: <strong>sette punti vendita</strong>, una ricetta riconoscibile e una clientela fedele.
      Oggi però ogni sede lavora come un'isola. Ordini al laboratorio, scorte, cassa, fidelizzazione e clienti aziendali seguono strumenti e abitudini diverse.
      Il risultato sono <strong>costi nascosti</strong>: sprechi di produzione, ore amministrative ripetute e opportunità commerciali che non vengono colte.
    </P>
    <P>
      Il presente piano propone di unificare l'intero gruppo sotto <strong>Synapse OS</strong>, una piattaforma gestionale già esistente e collaudata.
      Synapse OS diventa il "Cervello Digitale" dell'azienda e lavora su tre obiettivi strategici:
    </P>
    <Bullets
      items={[
        <><strong>Abbattere i costi operativi</strong>: produzione pianificata sui dati reali di vendita, scorte visibili in tempo reale e amministrazione centralizzata.</>,
        <><strong>Lanciare una linea B2B ad alto margine</strong>: strenne natalizie e regalistica aziendale vendute tramite un portale con preventivo immediato.</>,
        <><strong>Preparare il brand al franchising</strong>: processi, standard e numeri replicabili, condizione necessaria per attrarre affiliati qualificati.</>,
      ]}
    />
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 my-10">
      <Kpi testId="kpi-payback" value={`${payback}° mese`} label="Rientro stimato (Opzione A)" />
      <Kpi testId="kpi-b2b" value="€ 60.000" label="Vendite B2B anno 1 (scenario medio)" />
      <Kpi testId="kpi-waste" value="–3%" label="Sprechi su costo materie prime" />
      <Kpi testId="kpi-discount" value="–18%" label="Sconto Partner Fondatore" />
    </div>
    <Callout title="In sintesi per la Proprietà">
      Con l'Opzione A l'investimento iniziale è di <strong>€ 11.900</strong>, pagabile in tre tranche, e il canone è di <strong>€ 690 al mese</strong>, pari a circa € 99 per punto vendita.
      Considerando anche budget pubblicitario e restyling, nello scenario medio l'intero programma <strong>si ripaga entro l'{payback}° mese</strong>.
      Tutte le stime sono prudenti e dichiarate. I numeri dettagliati sono riportati nelle sezioni 5 e 6.
    </Callout>
  </Section>
);
